// The undo stack, ported from frontend/tools/undo_redo_manager.py.
export interface Command { execute(): void; undo(): void; readonly description: string }

export class UndoRedoManager {
  static MAX_HISTORY = 200;
  private undoStack: Command[] = [];
  private redoStack: Command[] = [];

  execute(c: Command): void {
    c.execute();
    this.undoStack.push(c);
    if (this.undoStack.length > UndoRedoManager.MAX_HISTORY) this.undoStack.shift();
    this.redoStack = [];
  }
  undo(): string | null {
    const c = this.undoStack.pop();
    if (!c) return null;
    c.undo();
    this.redoStack.push(c);
    return c.description;
  }
  redo(): string | null {
    const c = this.redoStack.pop();
    if (!c) return null;
    c.execute();
    this.undoStack.push(c);
    return c.description;
  }
  canUndo() { return this.undoStack.length > 0; }
  canRedo() { return this.redoStack.length > 0; }
  clear() { this.undoStack = []; this.redoStack = []; }
  get undoDescription(): string | null { return this.undoStack.at(-1)?.description ?? null; }
  get redoDescription(): string | null { return this.redoStack.at(-1)?.description ?? null; }
}
